import React, { useEffect } from "react";
import { Link } from "react-router-dom";

function ModalTerms() {
  useEffect(() => {
    document.title = "Flipcard - Terms and Conditions";
    return () => {
      document.title = "Flipcard";
    };
  }, []);
  return (
    <div className="terms">
      <h2 className="darktextColor textNavbarBrand">Terms and Conditions</h2>
      <p className="darktextColor textSmall">
        Last Updated : 15 February 2021 19.39.34 UTC+7
      </p>
      <div className="terms-box">
        <p className="darktextColor text">
          By registering for the Flipcard service, you have agreed to the
          following Terms and Conditions of Service. All kinds of new features
          on the Service will be bound by these Terms and Conditions. Flipcard
          reserves the right to make changes at any time.
        </p>
        <h5 className="darktextColor textTitle">General Terms</h5>
        <ol className="darktextColor text">
          <li>
            Flipcard reserves the right to change or cancel this Service for any
            reason and without prior notice.
          </li>
          <li>
            This service is provided as is without warranty of any kind, express
            or implied. The risk of using this service is your risk. And you do
            not have the right to ask for any compensation from us.
          </li>
          <li>
            You have to keep your passwords secure, flipcard will not be
            responsible for any loss and damage arising from your inability to
            maintain the security of your password.
          </li>
          <li>
            We do not guarantee that this Service will be safe or error-free
          </li>
        </ol>

        <h5 className="darktextColor textTitle">User</h5>
        <ol className="darktextColor text">
          <li>
            You are responsible for all content (data, text, photos, images,
            links) that you upload through your account on Flipcard.
          </li>
          <li>
            Flipcard does not allow the use for illegal activities and violates
            the laws (including copyright laws).
          </li>
          <li>
            You agree that the data that you input on the flipcard is data that
            you want to share with the public
          </li>
          <li>
            You are prohibited from sending all kinds of worms, viruses, code
            that is destructive.
          </li>
          <li>
            You agree that if your account has passed the active period of more
            than 30 days it will be automatically deleted
          </li>
        </ol>
        <h5 className="darktextColor textTitle">Closing</h5>
        <ol className="darktextColor text">
          <li>
            Flipcard reserves the right to immediately suspend, limit or
            terminate the service if we have reason to suspect that you have
            violated the provisions of the Terms and Conditions and applicable
            laws and regulations.
          </li>
        </ol>
        <p className="darktextColor textSmall ">
          <Link to="/" className="link-back darktextColor">
            &larr; back
          </Link>
        </p>
      </div>
    </div>
  );
}

export default ModalTerms;
